import React, {useEffect, useState} from 'react';
import { Modal, Button, Form, Row, Col, Card, Table, Badge, Dropdown, Pagination,  } from 'react-bootstrap';
import {useNavigate} from "react-router-dom";
import FormControl from "../../../shared/components/FormControl";
import {businessYearService} from "../../../services/businessYearService";
import eventEmitter from "../../../shared/eventEmitter";
import {EventEmitterTypes} from "../../../shared/eventEmitterEnum";
import notificationService from "../../../services/NotificationService";
import NotificationService from "../../../services/NotificationService";

interface PricePerSqFtModalProps {
    MaximumWorkAmountPerDay?: number;
    startDateProp: string,
    webPriceAdjustmentAmount: number;
    endDateProp: string,
    year: number;
    show: boolean;
    toggle: () => void;
}


const MaxDailyValueModal: React.FC<PricePerSqFtModalProps> = ({MaximumWorkAmountPerDay, webPriceAdjustmentAmount,startDateProp, endDateProp, year, show, toggle}) => {
    const [maxValue, setMaxValue] = useState<number>(0);
    const [startDate, setStartDate] = useState<string>(null);
    const [endDate, setEndDate] = useState<string>(null);
    const [showErrors, setShowErrors] = useState(false);

    function handleSave() {
        const postData = {
            scheduleStartDate: startDate,
            scheduleEndDate: endDate,
            maximumWorkAmountPerDay: maxValue,
            webPriceAdjustmentAmount: webPriceAdjustmentAmount
        }
        businessYearService.updateSeasonalInfo(postData, year).then(r => {
            eventEmitter.emit(EventEmitterTypes.REFRESH_LOADED_YEAR_MAX_DAILY)
            eventEmitter.emit(EventEmitterTypes.REFRESH_YEARLY_SETTINGS)
            toggle();
        })
    }
    useEffect(() => {
        setMaxValue(MaximumWorkAmountPerDay);
        setStartDate(startDateProp);
        setEndDate(endDateProp);
    }, [MaximumWorkAmountPerDay, startDateProp, endDateProp]);
    
    return (
        <Modal show={show} onHide={toggle}>
            <Modal.Header closeButton>
                <h5 className="modal-title" id="profileModalTitle">Max Daily Value</h5>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="row gx-3">
                        <Form.Group controlId="maxValue" className="col-md-6 mb-3">
                            <FormControl
                                type="number"
                                label={"Max Daily Value"}
                                value={maxValue}
                                placeholder='Max Value'
                                showErrors={showErrors}
                                onChange={(e) => setMaxValue(parseFloat(e.target.value))}
                                required
                            />
                        </Form.Group>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn btn-primary text-strong text-uppercase m-100" onClick={handleSave}>
                    Save
                </Button>
                <Button className="btn btn-cancel text-strong text-uppercase m-100" onClick={toggle}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MaxDailyValueModal;
